import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer, { INITIAL_STATE } from './rootReducer';
import rootSaga from './rootSaga';
import { Creators as actions } from './actions';

const reduxDevToolsExtension = require('redux-devtools-extension');

const bindMiddleware = middleware => {
    // if (process.env.NODE_ENV !== 'production') {
        const { composeWithDevTools } = reduxDevToolsExtension;
        return composeWithDevTools(applyMiddleware(...middleware));
    // }
    return applyMiddleware(...middleware);
};

function configureStore(state = INITIAL_STATE) {
    let store;

    const sagaMiddleware = createSagaMiddleware({
        // Unexpected errors triggered from a saga
        onError: error => {
            // Show the stack trace in console
            console.error(error);

            // Send an action for the User
            store.dispatch(actions.handleError(error));
        }
    });

    store = createStore(
        rootReducer,
        state,
        bindMiddleware([sagaMiddleware])
    );

    store.sagaTask = sagaMiddleware.run(rootSaga);

    return store;
}

export default configureStore;
